module.exports = __webpack_public_path__ + "img/FPT07.531bb372.svg";